import { Box } from "@mui/material"
import DekuStickItem, { SimpleDekuStickItem } from "../inventory/items/DekuStickItem"
import DekuNutItem, { SimpleDekuNutItem } from "../inventory/items/DekuNutsItem"
import BombItem, { SimpleBombItem } from "../inventory/items/BombItem"
import BowItem, { SimpleBowItem } from "../inventory/items/BowItem"
import FireArrowItem, { SimpleFireArrowItem } from "../inventory/items/FireArrowItem"
import DinsFireItem, { SimpleDinsFireItem } from "../inventory/items/DinsFireItem"
import SlingshotItem, { SimpleSlingshotItem } from "../inventory/items/SlingshotItem"
import OcarinaItem, { SimpleOcarinaItem } from "../inventory/items/OcarinaItem"
import BombchusItem, { SimpleBombchusItem } from "../inventory/items/BombchusItem"
import HookshotItem, { SimpleHookshotItem } from "../inventory/items/HookshotItem"
import IceArrowItem, { SimpleIceArrowItem } from "../inventory/items/IceArrowItem"
import FaroresWindItem, { SimpleFaroresWindItem } from "../inventory/items/FaroresWindItem"
import BoomrangItem, { SimpleBoomrangItem } from "../inventory/items/BoomrangItem"
import LensOfTruthItem, { SimpleLensOfTruthItem } from "../inventory/items/LensOfTruthItem"
import MagicBeansItem, { SimpleMagicBeansItem } from "../inventory/items/MagicBeansItem"
import MegatonHammerItem, { SimpleMegatonHammerItem } from "../inventory/items/MegatonHammerItem"
import LightArrowItem, { SimpleLightArrowItem } from "../inventory/items/LightArrowItem"
import NayrusLoveItem, { SimpleNayrusLoveItem } from "../inventory/items/NayrusLoveItem"
import { CommonBigPoeBottleItem } from "../inventory/items/BigPoeBottleItem"
import { CommonEmptyBottleItem, SimpleEmptyBottleItem } from "../inventory/items/EmptyBottle"
import MagicItem, { SimpleMagicItem } from "../inventory/items/MagicItem"
import WalletItem, { SimpleWalletItem } from "../inventory/items/WalletItem"
import ScaleItem, { SimpleScaleItem } from "../inventory/items/ScaleItem"
import StrengthItem, { SimpleStrengthItem } from "../inventory/items/StrengthItem"
import KokiriSwordItem, { SimpleKokiriSwordItem } from "../inventory/items/KokiriSwordItem"
import HylianShieldItem, { SimpleHylianShieldItem } from "../inventory/items/HylianShieldItem"
import GoronTunicItem, { SimpleGoronTunicItem } from "../inventory/items/GoronTunicItem"
import IronBootsItem, { SimpleIronBootsItem } from "../inventory/items/IronBootsItem"
import TokenItemCounter, { SimpleGoldenSkultulaItem } from "../inventory/items/TokenCounterItem"
import BiggoronSwordItem, { SimpleBiggoronSwordItem } from "../inventory/items/BiggoronSwordItem"
import MirrorShieldItem, { SimpleMirrorShieldItem } from "../inventory/items/MirrorShieldItem"
import ZoraTunicItem, { SimpleZoraTunicItem } from "../inventory/items/ZoraTunicItem"
import HoverBootsItem, { SimpleHoverBootsItem } from "../inventory/items/HoverBootsItem"
import { SimpleRutoLetterItem } from "../inventory/items/RutoLetterBottle"
import { SimpleZeldaLullabySong } from "../inventory/songs/ZeldaLullabySong"
import { SimpleEponaSong } from "../inventory/songs/EponaSong"
import { SimpleSariaSong } from "../inventory/songs/SariaSong"
import { SimpleSunSong } from "../inventory/songs/SunSong"
import { SimpleTimeSong } from "../inventory/songs/TimeSong"
import { SimpleStormSong } from "../inventory/songs/StormSong"
import { SimpleMinuet } from "../inventory/songs/MinuetOfForest"
import { SimpleBolero } from "../inventory/songs/BoleroOfFire"
import { SimpleSerenade } from "../inventory/songs/SerenadeOfWater"
import { SimpleNocturne } from "../inventory/songs/NocturneOfShadow"
import { SimpleRequiem } from "../inventory/songs/RequiemOfSpirit"
import { SimplePrelude } from "../inventory/songs/PreludeOfLight"
import SmallKeyItem from "../keysanity/SmallKeyItem"
import { DungeonsKeysList } from "../keysanity/DungeonsKeysData"
import { SimpleGerudoCardItem } from "../inventory/items/GerudoCardItem"
import { SimpleBlueFireBottleItem } from "../inventory/items/BlueFireBottleItem"
import { SimpleDekuShieldItem } from "../inventory/items/DekuShieldItem"
import { SimpleButtonAItem } from "../../core/assets/command/n64Buttons/items/ButtonAItem"
import { SimpleButtonCLeftItem } from "../../core/assets/command/n64Buttons/items/ButtonCLeftItem"
import { SimpleButtonCRightItem } from "../../core/assets/command/n64Buttons/items/ButtonCRightItem"
import { SimpleButtonCDownItem } from "../../core/assets/command/n64Buttons/items/ButtonCDownItem"
import { SimplePocketCuccoItem } from "../inventory/items/PockeCuccoItem"
import { SimpleCojiroItem } from "../inventory/items/CojiroItem"
import { SimpleOddPotionItem } from "../inventory/items/OddPotionItem"
import { SimpleOddMushroomItem } from "../inventory/items/OddMushroomItem"
import { SimpleSawItem } from "../inventory/items/SawItem"
import { SimpleBrokenKnifeItem } from "../inventory/items/BrokenKnifeItem"
import { SimplePrescriptionItem } from "../inventory/items/PrescriptionItem"
import { SimpleEyeballFrogItem } from "../inventory/items/EyeBallFrogItem"
import { SimpleEyedropItem } from "../inventory/items/EyedropItem"
import { SimpleClaimCheckItem } from "../inventory/items/ClaimCheckItem"
import { SimpleBunnyHoodItem, SimpleKeatonMaskItem, SimpleMaskOfTruthItem, SimpleSkullMaskItem, SimpleSpookyMaskItem, SimpleZeldaLetterItem } from "../inventory/items/ChildSequenceItem"
import { OotItemDto } from "../hints/OotItemAutocomplete"
import { SimpleButtonCUpItem } from "../../core/assets/command/n64Buttons/items/ButtonCUpItem"

interface ReworkItemTrackerProps {
    top: number,
    left: number,
    onSelectItem?: (o: OotItemDto) => void
}

const ReworkItemTracker = (props: ReworkItemTrackerProps) => {

    let originTop = 10;
    let originLeft = 10;

    return <Box position="absolute" top={props.top} left={props.left} width={220} height={220}>
         <Box position={"absolute"} top={originTop} left={originLeft}>
        <DekuStickItem  />
      </Box>
      <Box position={"absolute"} top={originTop} left={originLeft + 32}>
        <DekuNutItem />
      </Box>
      <Box position={"absolute"} top={originTop} left={originLeft + 64}>
        <BombItem />
      </Box>
      <Box position={"absolute"} top={originTop} left={originLeft + 96}>
        <BowItem />
      </Box>
      <Box position={"absolute"} top={originTop} left={originLeft + 128}>
        <FireArrowItem />
      </Box>
      <Box position={"absolute"} top={originTop} left={originLeft + 160}>
        <DinsFireItem />
      </Box>

      {/* Line 2 */}
      <Box position={"absolute"} top={originTop + 32} left={originLeft}>
        <SlingshotItem />
      </Box>
      <Box position={"absolute"} top={originTop + 32} left={originLeft+32}>
        <OcarinaItem />
      </Box>
      <Box position={"absolute"} top={originTop + 32} left={originLeft+64}>
        <BombchusItem />
      </Box>
      <Box position={"absolute"} top={originTop + 32} left={originLeft+96}>
        <HookshotItem />
      </Box>
      <Box position={"absolute"} top={originTop+ 32} left={originLeft+128}>
        <IceArrowItem />
      </Box>
      <Box position={"absolute"} top={originTop+ 32} left={originLeft+160}>
        <FaroresWindItem />
      </Box>

      {/* Line 3 */}
      <Box position={"absolute"} top={originTop+64} left={originLeft}>
        <BoomrangItem />
      </Box>
      <Box position={"absolute"} top={originTop+64} left={originLeft+32}>
        <LensOfTruthItem />
      </Box>
      <Box position={"absolute"} top={originTop+64} left={originLeft+64}>
        <MagicBeansItem />
      </Box>
      <Box position={"absolute"} top={originTop+64} left={originLeft+96}>
        <MegatonHammerItem />
      </Box>
      <Box position={"absolute"} top={originTop+64} left={originLeft+128}>
        <LightArrowItem />
      </Box>
      <Box position={"absolute"} top={originTop+64} left={originLeft+160}>
        <NayrusLoveItem />
      </Box>

      {/* Line 4 */}
      <Box position={"absolute"} top={originTop+96} left={originLeft}>
        <CommonBigPoeBottleItem />
      </Box>
      <Box position={"absolute"} top={originTop+96} left={originLeft+32}>
        <CommonEmptyBottleItem />
      </Box>
      <Box position={"absolute"} top={originTop+96} left={originLeft+64}>
        <MagicItem />
      </Box>
      <Box position={"absolute"} top={originTop+96} left={originLeft+96}>
        <WalletItem />
      </Box>
      <Box position={"absolute"} top={originTop+96} left={originLeft+128}>
        <ScaleItem />
      </Box>
      <Box position={"absolute"} top={originTop+96} left={originLeft+160}>
        <StrengthItem />
      </Box>

      {/* Equipements */}
      {/* Line 1 */}
      <Box position={"absolute"} top={originTop+128} left={originLeft}>
        <KokiriSwordItem />
      </Box>
      <Box position={"absolute"} top={originTop+128} left={originLeft+32}>
        <HylianShieldItem />
      </Box>
      <Box position={"absolute"} top={originTop+128} left={originLeft+64}>
        <GoronTunicItem />
      </Box>
      <Box position={"absolute"} top={originTop+128} left={originLeft+96}>
        <IronBootsItem />
      </Box>
      <Box position={"absolute"} top={originTop+140} left={originLeft+145}>
        <TokenItemCounter />
      </Box>

      {/* Line 2 */}
      <Box position={"absolute"} top={originTop+160} left={originLeft}>
        <BiggoronSwordItem />
      </Box>
      <Box position={"absolute"} top={originTop+160} left={originLeft+32}>
        <MirrorShieldItem />
      </Box>
      <Box position={"absolute"} top={originTop+160} left={originLeft+64}>
        <ZoraTunicItem />
      </Box>
      <Box position={"absolute"} top={originTop+160} left={originLeft+96}>
        <HoverBootsItem />
      </Box>
    </Box>
}

export default ReworkItemTracker


export const ReworkDragDropItemTracker = (props: ReworkItemTrackerProps) => {

  let originTop = 10;
  let originLeft = 10;

  return <Box position="relative" top={props.top} left={props.left} width={220} height={500}>
       <Box position={"absolute"} top={originTop} left={originLeft}>
      <SimpleDekuStickItem onClick={props.onSelectItem} />
    </Box>
    <Box position={"absolute"} top={originTop} left={originLeft + 32}>
      <SimpleDekuNutItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop} left={originLeft + 64}>
      <SimpleBombItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop} left={originLeft + 96}>
      <SimpleBowItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop} left={originLeft + 128}>
      <SimpleFireArrowItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop} left={originLeft + 160}>
      <SimpleDinsFireItem onClick={props.onSelectItem}/>
    </Box>

    {/* Line 2 */}
    <Box position={"absolute"} top={originTop + 32} left={originLeft}>
      <SimpleSlingshotItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop + 32} left={originLeft+32}>
      <SimpleOcarinaItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop + 32} left={originLeft+64}>
      <SimpleBombchusItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop + 32} left={originLeft+96}>
      <SimpleHookshotItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+ 32} left={originLeft+128}>
      <SimpleIceArrowItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+ 32} left={originLeft+160}>
      <SimpleFaroresWindItem onClick={props.onSelectItem}/>
    </Box>

    {/* Line 3 */}
    <Box position={"absolute"} top={originTop+64} left={originLeft}>
      <SimpleBoomrangItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+64} left={originLeft+32}>
      <SimpleLensOfTruthItem onClick={props.onSelectItem} />
    </Box>
    <Box position={"absolute"} top={originTop+64} left={originLeft+64}>
      <SimpleMagicBeansItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+64} left={originLeft+96}>
      <SimpleMegatonHammerItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+64} left={originLeft+128}>
      <SimpleLightArrowItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+64} left={originLeft+160}>
      <SimpleNayrusLoveItem onClick={props.onSelectItem}/>
    </Box>

    {/* Line 4 */}
    <Box position={"absolute"} top={originTop+96} left={originLeft}>
      <SimpleRutoLetterItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+96} left={originLeft+32}>
      <SimpleEmptyBottleItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+96} left={originLeft+64}>
      <SimpleMagicItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+96} left={originLeft+96}>
      <SimpleWalletItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+96} left={originLeft+128}>
      <SimpleScaleItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+96} left={originLeft+160}>
      <SimpleStrengthItem onClick={props.onSelectItem}/>
    </Box>

    {/* Equipements */}
    {/* Line 1 */}
    <Box position={"absolute"} top={originTop+128} left={originLeft}>
      <SimpleKokiriSwordItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+128} left={originLeft+32}>
      <SimpleHylianShieldItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+128} left={originLeft+64}>
      <SimpleGoronTunicItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+128} left={originLeft+96}>
      <SimpleIronBootsItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+140} left={originLeft+145}>
      <SimpleGoldenSkultulaItem onClick={props.onSelectItem}/>
    </Box>

    {/* Line 2 */}
    <Box position={"absolute"} top={originTop+160} left={originLeft}>
      <SimpleBiggoronSwordItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+160} left={originLeft+32}>
      <SimpleMirrorShieldItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+160} left={originLeft+64}>
      <SimpleZoraTunicItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+160} left={originLeft+96}>
      <SimpleHoverBootsItem onClick={props.onSelectItem}/>
    </Box>

    <Box position={"absolute"} top={originTop+195} left={originLeft}>
      <SimpleZeldaLullabySong onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+195} left={originLeft+32}>
      <SimpleEponaSong onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+195} left={originLeft+64}>
      <SimpleSariaSong onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+195} left={originLeft+96}>
      <SimpleSunSong onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+195} left={originLeft+128}>
      <SimpleTimeSong onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+195} left={originLeft+160}>
      <SimpleStormSong onClick={props.onSelectItem}/>
    </Box>

    <Box position={"absolute"} top={originTop+230} left={originLeft}>
      <SimpleMinuet onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+230} left={originLeft+32}>
      <SimpleBolero onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+230} left={originLeft+64}>
      <SimpleSerenade onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+230} left={originLeft+96}>
      <SimpleNocturne onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+230} left={originLeft+128}>
      <SimpleRequiem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+230} left={originLeft+160}>
      <SimplePrelude onClick={props.onSelectItem}/>
    </Box>

    <Box position={"absolute"} top={originTop+265} left={originLeft}>
      <SmallKeyItem data={DungeonsKeysList.filter(x => x.dungeon === "Forest")[0]} id="ForestKey"  hideKeys onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+265} left={originLeft+32}>
      <SmallKeyItem data={DungeonsKeysList.filter(x => x.dungeon === "Fire")[0]} id="FireKey"  hideKeys onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+265} left={originLeft+64}>
      <SmallKeyItem data={DungeonsKeysList.filter(x => x.dungeon === "Water")[0]} id="WaterKey"  hideKeys onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+265} left={originLeft+96}>
      <SmallKeyItem data={DungeonsKeysList.filter(x => x.dungeon === "Shadow")[0]} id="ShadowKey"  hideKeys onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+265} left={originLeft+128}>
      <SmallKeyItem data={DungeonsKeysList.filter(x => x.dungeon === "Spirit")[0]} id="SpiritKey"  hideKeys onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+265} left={originLeft+160}>
      <SmallKeyItem data={DungeonsKeysList.filter(x => x.dungeon === "Ganon")[0]} id="GanonKey"  hideKeys onClick={props.onSelectItem}/>
    </Box>

    <Box position={"absolute"} top={originTop+300} left={originLeft}>
      <SmallKeyItem data={DungeonsKeysList.filter(x => x.dungeon === "BotW")[0]} id="BotWKey"  hideKeys onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+300} left={originLeft+32}>
      <SmallKeyItem data={DungeonsKeysList.filter(x => x.dungeon === "GTG")[0]} id="GTGKey"  hideKeys onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+300} left={originLeft+64}>
      <SmallKeyItem data={DungeonsKeysList.filter(x => x.dungeon === "Fortress")[0]} id="FortressKey"  hideKeys onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+300} left={originLeft+96}>
    </Box>
    <Box position={"absolute"} top={originTop+300} left={originLeft+128}>
    </Box>
    <Box position={"absolute"} top={originTop+300} left={originLeft+160}>
    </Box>

    <Box position={"absolute"} top={originTop+335} left={originLeft}>
      <SimpleGerudoCardItem  onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+335} left={originLeft+32}>
      <SimpleBlueFireBottleItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+335} left={originLeft+64}>
      <SimpleDekuShieldItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+335} left={originLeft+96}>
    </Box>
    <Box position={"absolute"} top={originTop+335} left={originLeft+128}>
    </Box>
    <Box position={"absolute"} top={originTop+335} left={originLeft+160}>
    </Box>

    <Box position={"absolute"} top={originTop+370} left={originLeft}>
      <SimpleButtonAItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+370} left={originLeft+32}>
      <SimpleButtonCUpItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+370} left={originLeft+64}>
      <SimpleButtonCLeftItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+370} left={originLeft+96}>
      <SimpleButtonCRightItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+370} left={originLeft+128}>
      <SimpleButtonCDownItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+370} left={originLeft+160}>
    </Box>


    <Box position={"absolute"} top={originTop+405} left={originLeft}>
      <SimplePocketCuccoItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+405} left={originLeft+32}>
      <SimpleCojiroItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+405} left={originLeft+64}>
      <SimpleOddMushroomItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+405} left={originLeft+96}>
      <SimpleOddPotionItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+405} left={originLeft+128}>
      <SimpleSawItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+405} left={originLeft+160}>
      <SimpleBrokenKnifeItem onClick={props.onSelectItem}/>
    </Box>

    <Box position={"absolute"} top={originTop+440} left={originLeft}>
      <SimplePrescriptionItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+440} left={originLeft+32}>
      <SimpleEyeballFrogItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+440} left={originLeft+64}>
      <SimpleEyedropItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+440} left={originLeft+96}>
      <SimpleClaimCheckItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+440} left={originLeft+128}>
    </Box>
    <Box position={"absolute"} top={originTop+440} left={originLeft+160}>
    </Box>

    <Box position={"absolute"} top={originTop+475} left={originLeft}>
      <SimpleZeldaLetterItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+475} left={originLeft+32}>
      <SimpleKeatonMaskItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+475} left={originLeft+64}>
      <SimpleSkullMaskItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+475} left={originLeft+96}>
      <SimpleSpookyMaskItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+475} left={originLeft+128}>
      <SimpleMaskOfTruthItem onClick={props.onSelectItem}/>
    </Box>
    <Box position={"absolute"} top={originTop+475} left={originLeft+160}>
      <SimpleBunnyHoodItem onClick={props.onSelectItem}/>
    </Box>


  </Box>
}